import { DialogContent, DialogTitle } from '@mui/material';
import { Button, Modal } from 'antd';
import { History } from '../../../../../common/components/History/History';
import { useGetOfferHistoryQuery } from '../store/offer.api';

interface IOfferHistoryProps {
  isOpen: boolean;
  onClose: () => void;
  offerId: string;
}

export const OfferHistory: React.FC<IOfferHistoryProps> = ({
  isOpen,
  onClose,
  offerId,
}) => {
  const { data: historyData, isLoading } = useGetOfferHistoryQuery(offerId);

  return (
    <Modal
      open={isOpen}
      width={1024}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      <DialogTitle>Offer History</DialogTitle>
      <DialogContent>
        <History data={historyData?.data || []} isLoading={isLoading} />
      </DialogContent>
    </Modal>
  );
};
